var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',_vm._b({},'loader',{ loading: _vm.loading },false),[_c('page-navigation',{attrs:{"title":("" + (_vm.team.name))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }